var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSportsGames = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Soccer-Player--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Soccer Player Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.42 5a2.52 2.52 0 0 0 2.45 -2A2.5 2.5 0 1 0 12 2a2.46 2.46 0 0 0 0.36 1.88A2.5 2.5 0 0 0 14.42 5Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 1.48a1.23 1.23 0 0 0 -1.47 1l-0.36 1.74A2.77 2.77 0 0 1 16 6.39l-5.32 0.07a5.28 5.28 0 0 0 -5.08 4.2l-0.15 0.76a1.24 1.24 0 0 0 1 1.47 1.25 1.25 0 0 0 1.48 -1l0.15 -0.76a2.76 2.76 0 0 1 2 -2.09l-1.75 8.32a1.25 1.25 0 1 0 2.44 0.5l0.41 -2a0.5 0.5 0 0 1 0.59 -0.39 0.51 0.51 0 0 1 0.39 0.59l-1.31 6.39a1.26 1.26 0 0 0 1 1.48 1.25 1.25 0 0 0 1.47 -1l2.86 -14.05a5.28 5.28 0 0 0 4.94 -4.19L21.47 3a1.23 1.23 0 0 0 -0.97 -1.52Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21.47a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSportsGames);
export default ForwardRef;